// /settings/sessions — «Сеансы» (001, FR-009): число сеансов и «Выйти на всех устройствах».
import { createFileRoute } from '@tanstack/react-router';
import { SessionsPage } from '../../../features/profile/SessionsPage.tsx';

export const Route = createFileRoute('/_app/_settings/settings/sessions')({
  staticData: { crumb: 'Сеансы' },
  component: SessionsPage,
});
